import {Component, ElementRef, Renderer2, ChangeDetectorRef, ViewEncapsulation, AfterViewInit} from '@angular/core';
import { PONodeComponent } from '../abstract-classes/po-node/ponode.component';
import { DetailScreensService } from '../detail-screens-module/services/detail-screens-service';
import { DomService } from '../../../services/dom-service/dom.service';
import { ProductOverviewService } from '../../../services/product-overview/product-overview.service';
import { UiHelperService } from '../../../services/shared/helpers/ui-helper.service';
import { PopupService } from '../popup-component/popup.service/popup.service';

@Component({
  selector: 'app-product-node',
  templateUrl: '../abstract-classes/po-node/ponode.component.html',
  styleUrls: ['../abstract-classes/po-node/ponode.component.css'],
})
export class ProductNodeComponent extends PONodeComponent {

  nodeType = 'product-node';
  expanded = true;

  constructor(domService: DomService, productOverviewService: ProductOverviewService,
              el: ElementRef, renderer: Renderer2, changeRef: ChangeDetectorRef,
              detailsScreenService: DetailScreensService, popupService: PopupService, uiHelper: UiHelperService) {
    super(domService, detailsScreenService, changeRef, el, renderer, productOverviewService, popupService, uiHelper);
  }

  initializeComponents() {
    this.listOfArrangementsToCreate = Object.assign([], this.hierarchyChildren);
    this.children = this.createArrangements();
    const numberOfChildren = this.children.length;
    if (this.productCluster === this.data.product) {
      this.expanded = true;
    }
    if (numberOfChildren > 0) {
      this.children[numberOfChildren - 1].isLastChild = true;
    }
  }
}
